/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingModeEnum = 'TRIAL' | 'REGULAR' | 'DISCONNECTED';

export const BillingModeEnum = {

    TRIAL: 'TRIAL' as BillingModeEnum,

    REGULAR: 'REGULAR' as BillingModeEnum,

    DISCONNECTED: 'DISCONNECTED' as BillingModeEnum
};

